var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('app-heading',{attrs:{"title":_vm.$t('pages.program.title')}}),_vm._v(" "),_c('program-days')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }